"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PythnetClient = void 0;
const anchor_1 = require("@coral-xyz/anchor");
const client_1 = require("@pythnetwork/client");
const pdas_1 = require("./pdas");
const bn_1 = require("./utils/bn");
const wallet_1 = require("./utils/wallet");
const StakeCapsParametersIdl = __importStar(require("../idl/stake-caps-parameters.json"));
class PythnetClient {
    connection;
    provider;
    stakeCapParametersProgram;
    constructor(connection) {
        this.connection = connection;
        this.provider = new anchor_1.AnchorProvider(connection, wallet_1.DummyWallet);
        this.stakeCapParametersProgram = new anchor_1.Program(StakeCapsParametersIdl, this.provider);
    }
    async getPublisherNumberOfSymbols() {
        const publisherNumberOfSymbols = {};
        const pythAccounts = await this.connection.getProgramAccounts((0, client_1.getPythProgramKeyForCluster)("pythnet"));
        for (const account of pythAccounts) {
            const base = (0, client_1.parseBaseData)(account.account.data);
            if (base?.type === client_1.AccountType.Price) {
                const parsed = (0, client_1.parsePriceData)(account.account.data);
                for (const priceComponent of parsed.priceComponents) {
                    publisherNumberOfSymbols[priceComponent.publisher.toBase58()] =
                        (publisherNumberOfSymbols[priceComponent.publisher.toBase58()] ??
                            0) + 1;
                }
            }
        }
        return publisherNumberOfSymbols;
    }
    async getStakeCapParameters() {
        const parameters = await this.stakeCapParametersProgram.account.parameters.fetch((0, pdas_1.getStakeCapsParametersAddress)()[0]);
        return (0, bn_1.convertBNToBigInt)(parameters);
    }
}
exports.PythnetClient = PythnetClient;
